export default __webpack_public_path__ + "static/media/logo.f3865bd9.svg";